import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum DeviceTypeId {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}

export class DeviceType extends Codebook<DeviceTypeId> {
  static readonly DESKTOP = new DeviceType(DeviceTypeId.DESKTOP, () => $t('Desktop'))
  static readonly MOBILE = new DeviceType(DeviceTypeId.MOBILE, () => $t('Mobile'))

  private constructor(
    id: DeviceTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
